<main class="app-container start">
  {#if isMobileDevice}
      {#if isFtus}
        <section 
            class="ftus-mobile {isMobilePanelCanScroll ? 'scroll' : ''}" 
            out:slideLeftOut="{{ delay: 250, duration: 300, easing: quintOut }}">
            <Splash>
              <Welcome />
            </Splash>
            {#if isFirstVisit}
              <SidePanel on:mount={onSidePanelMount}>
                <div class="component-container">
                  <LocationSearch isFtus={isFtus} />
                </div>
                <div class="component-container {stickyShowMap ? 'mb-offset' : ''}">
                  <FloodLikelihood isFtus={isFtus} isMobile={isMobileDevice} stickyShowMap={stickyShowMap} />
                </div>
              </SidePanel>
            {/if}
        </section>
      {:else}
        <section class="mobile-container {!isFtus ? "push-in" : "" }"
          transition:fade="{{ delay: 500, duration: 250 }}">
          <SocialShare />
          <ComboInput />
          <Legend activeRegion={activeRegion} inPanel={true} />
          <FloodRiskProfile activeRegion={activeRegion} />
        </section> 
      {/if}      
  {:else}
    {#if isFtus}
      <WelcomeModal>
        <Welcome />
      </WelcomeModal>
    {/if}
    <SidePanel>
      <div class="flood-form-wrapper" bind:this={formWrapperElem}>
        <div class="component-container">
          <LocationSearch isFtus={isFtus} />
        </div>
        <FloodLikelihood isFtus={isFtus} isMobile={isMobileDevice} stickyShowMap={stickyShowMap} />
      </div>
      {#if !isFtus}
        <FloodRiskProfile />
      {/if}
    </SidePanel>
  {/if}
  
  <MapComponent isFtus={isFtus} isMobile={isMobileDevice} />

</main>


<script>
import { onMount } from "svelte/internal";
import Welcome from "./components/Welcome/Welcome.svelte";
Welcome;
import WelcomeModal from "./components/WelcomeModal/WelcomeModal.svelte";
WelcomeModal;
import Splash from "./components/Splash/Splash.svelte";
Splash;
import MapComponent from "./components/Map/Map.svelte";
MapComponent;
import Legend from "./components/Legend/Legend.svelte";
Legend;
import SidePanel from "./components/SidePanel/SidePanel.svelte";
SidePanel;
import FloodLikelihood from "./components/FloodLikelihood/FloodLikelihood.svelte";
FloodLikelihood;
import Footer from "./components/Footer/Footer.svelte";
Footer;
import FloodRiskProfile from "./components/FloodRiskProfile/FloodRiskProfile.svelte";
FloodRiskProfile;
import LocationSearch from "./components/LocationSearch/LocationSearch.svelte";
LocationSearch;
import ComboInput from "./components/ComboInput/ComboInput.svelte";
ComboInput;
import SocialShare from "./components/SocialShare/SocialShare.svelte";
SocialShare;
import { fade } from "svelte/transition";
fade;
import { quintOut } from "svelte/easing";
quintOut;
import AuthService from "./services/AuthService";
import store, { STATES_MAIN, STATES_START, STATES_LANDING, STATES_FIRST_VISIT } from "./state";
import utils from "./utils";
import storage from "./services/StorageService";
//@ts-ignore
// import ZingTouch from "zingtouch";
// html data
let isMobileDevice = utils.isMobileDevice();
let isFtus = true;
let isMobilePanelCanScroll = false;
let isFirstVisit = false;
let activeRegion = undefined;
let formWrapperElem;
let stickyShowMap = false;
let mobileFormWrapper;
export let config;
store.subscribe(state => {
    const isLanding = state.currentState.includes(`${STATES_MAIN.LANDING}`);
    const isSearching = state.currentState.includes(`${STATES_MAIN.FIRST_VISIT}.${STATES_FIRST_VISIT.SEARCHING}`) ||
        state.currentState.includes(`${STATES_MAIN.START}.${STATES_START.SEARCHING}`);
    isFirstVisit = state.currentState.includes(`${STATES_MAIN.FIRST_VISIT}`);
    isMobilePanelCanScroll = isMobileDevice && isSearching;
    if (!isLanding && !isSearching) {
        storage.setItem("ses-state", state.currentState);
    }
    isFtus = isLanding || isFirstVisit;
    isFirstVisit && state.splashHide && ftusShowMapPosition();
});
onMount(() => {
    const requiredParams = ["clientId", "clientSecret", "webMapId"];
    const hasRequiredParam = requiredParams.every(passedConfig => {
        return Object.keys(config).includes(passedConfig);
    });
    if (hasRequiredParam) {
        try {
            AuthService.authenticate(config.clientId, config.clientSecret).then(token => {
                store.update(state => {
                    state.config = config;
                    state.token = token;
                    state.currentState = `${STATES_MAIN.LANDING}.${STATES_LANDING.AUTHENTICATE_APP_SUCCESS}`;
                    return state;
                });
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    // setZingTouchArea();
    isFtus && ftusShowMapPosition();
    window.addEventListener("resize", () => {
        isMobileDevice = utils.isMobileDevice();
        isFtus && ftusShowMapPosition();
        // setZingTouchArea();
    });
});
//@ts-ignore
function slideLeftOut(node, { delay, duration, easing }) {
    return {
        delay,
        duration,
        easing,
        css: (t) => {
            return `
        transform: translateX(${-(1 - t) * 100}%);
      `;
        }
    };
}
function ftusShowMapPosition() {
    let formElement = isMobileDevice
        ? mobileFormWrapper
        : formWrapperElem;
    setTimeout(() => {
        if (formElement && formElement.scrollHeight > formElement.clientHeight) {
            stickyShowMap = true;
        }
        else {
            stickyShowMap = false;
        }
    });
}
function onSidePanelMount(val) {
    mobileFormWrapper = val.detail;
}
// function setZingTouchArea() {
//   activeRegion = isMobileDevice ? ZingTouch.Region(document.body) : undefined;
// }
</script>


<style>.app-container{display:none;height:100%;position:relative}.app-container.start{display:flex}.app-container .ftus-mobile{position:absolute;top:0;left:0;height:100%;width:100%;z-index:5}.app-container .ftus-mobile.scroll{overflow-y:auto}@media screen and (max-width:767px){.app-container.start{flex-direction:column-reverse;padding-top:0}}.flood-form-wrapper{overflow-y:auto;margin-bottom:70px;height:100%}.mobile-container{z-index:1}.component-container{margin-bottom:1.5625rem}.component-container.mb-offset{margin-bottom:1.875rem}</style>
